import { render, staticRenderFns } from "./AddRelationshipManagement.vue?vue&type=template&id=b1808808&scoped=true&"
import script from "./AddRelationshipManagement.vue?vue&type=script&lang=js&"
export * from "./AddRelationshipManagement.vue?vue&type=script&lang=js&"
import style0 from "./AddRelationshipManagement.vue?vue&type=style&index=0&id=b1808808&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1808808",
  null
  
)

export default component.exports